module.exports = __webpack_public_path__ + "img/np_OEMcontent_3233352_000000.d81e22dd.svg";